import { AppDispatch } from 'types/store'
import { fetchCurrentUserAction } from './authentication'
import { initializeRevenueCat, userLimitationsApi } from './billing'
import { findMyBusinesses } from './business'

export const load = (isLoggedIn: boolean) => async (dispatch: AppDispatch) => {
  if (isLoggedIn) {
    await Promise.all([
      dispatch(fetchCurrentUserAction()).unwrap(),
      dispatch(findMyBusinesses()),

      // Billing
      dispatch(initializeRevenueCat()),
      dispatch(
        userLimitationsApi.endpoints.getUserLimitations.initiate(undefined, {
          forceRefetch: true,
        })
      ),
    ])
  }
}
